import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { ManualLeafListing, ManualLeafAddEdit } from './Pages';

export const ManualLeafRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={ManualLeafAddEdit} />
        <Route exact path = {`${match.path}/AddEdit`} component={ManualLeafAddEdit} />
    </Fragment>
)